import React from 'react'
import { render } from 'react-dom'
import { BrowserRouter } from 'react-router-dom'
import { Provider } from 'react-redux'
import configureStore from 'store'
import { configureTranslation } from 'server/i18n/client'
import { serviceRouter } from 'routes'
import {
  ApolloClient,
  createNetworkInterface,
  ApolloProvider,
} from 'react-apollo'
import { defaultOptions } from 'server/api'
import Cookie from 'js-cookie'
import RestClient from 'frontend_core/dist/rest/client'
import { Host } from 'frontend_core/dist/helpers/url'

window.i18n = configureTranslation(__SPM_TRANSLATION__)
delete window.__SPM_TRANSLATION__

window.manifest = __SPM_MANIFEST__
delete window.__SPM_MANIFEST__

const preloadedState = window.__SPM_PRELOADED_STATE__
delete window.__SPM_PRELOADED_STATE__

const errorStatus = window.__SPM_ERROR_STATUS__
delete window.__SPM_ERROR_STATUS__

// server side rendering flag turns off
preloadedState.config.SSR = false
const config = preloadedState.config
const networkInterface = createNetworkInterface({
  uri: `${config.SPM_GRAPHQL_API_HOST}/graphql`,
})

networkInterface.use([
  {
    applyMiddleware(req, next) {
      if (!req.options.headers) req.options.headers = {}
      req.options.headers = Object.assign(
        req.options.headers,
        defaultOptions(
          {
            accessToken: Cookie.get('sm_at'),
            historyId: Cookie.get('Spacemarket-Forwarded-History-Id'),
            userAgent: window.navigator.userAgent,
            referrer: document.referrer,
          },
          config,
        ).headers,
      )
      next()
    },
  },
])
const apolloClient = new ApolloClient({
  networkInterface: networkInterface,
  initialState: window.__SPM_APOLLO_STATE__,
  ssrForceFetchDelay: 100,
})
const store = configureStore(preloadedState)
const AppRoute = serviceRouter(config.SERVICE, config.SSR, errorStatus)

RestClient.accessToken = Cookie.get('sm_at')
RestClient.apiHost = config.SPM_REST_API_HOST
RestClient.spmApiVersion = config.SPM_REST_API_VERSION
RestClient.apiKey = config.SPM_REST_API_KEY

const isDevelopment = config.ENV === 'development'

Host.configure(config, isDevelopment)

if (!isDevelopment) {
  // 本番のみsentry
  Sentry.init({ dsn: config.SENTRY_DSN })
}

render(
  <Provider store={store}>
    <ApolloProvider client={apolloClient} store={store}>
      <BrowserRouter>
        <AppRoute />
      </BrowserRouter>
    </ApolloProvider>
  </Provider>,
  document.getElementById('js-root'),
)
